import React, { FC, useCallback, useEffect, useMemo } from 'react'
import { Grid, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import { useParams, useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { get } from 'lodash'
import { TabsComponent } from '../../../../components/Tabs'
import { Loader } from '../../../../components/Loader'
import { businessEntityDetailsLoading, getBusinessEntityDetailsData } from '../../../../store/selectors'
import { getBusinessEntityDetailsRequest } from '../../../../store/actions'
import { tabList } from './tabList'
import { routes } from '../../../../constants/routes'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    paddingTop: theme.spacing(6),
  },
  titleWrap: {
    gap: theme.spacing(2),
    alignItems: 'center',
    color: theme.palette.primary.light,
  },
  titleId: {
    fontSize: 20,
  },
  infoWrap: {
    justifyContent: 'space-between',
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
  },
  section: {
    width: '100%',
  },
}))

export const BusinessEntityTabs: FC = () => {
  const classes = useStyles()
  const { id, tab } = useParams<{ [key: string]: string }>()
  const history = useHistory()
  const dispatch = useDispatch()
  const businessEntityDetailsIsLoading = useSelector(businessEntityDetailsLoading)
  const entity = useSelector(getBusinessEntityDetailsData)

  const activeTab = useMemo(() => {
    const currentTab = tabList.find((t) => t.slug === tab)
    return currentTab?.slug || tabList[0].slug
  }, [tab])

  const handleTabChange = useCallback(
    (key: string) => {
      history.push(`${routes.SETTINGS_ENTITY_DETAILS_TABS.replace(':id', id).replace(':tab?', key)}`)
    },
    [history, id],
  )

  useEffect(() => {
    dispatch(getBusinessEntityDetailsRequest({ id }))
  }, [dispatch, id])

  useEffect(() => {
    if (!tab) {
      history.push(`${routes.SETTINGS_ENTITY_DETAILS_TABS.replace(':id', id).replace(':tab?', activeTab)}`)
    }
  }, [tab, history, id, activeTab])

  return (
    <Grid container className={classes.container}>
      {entity && (
        <Grid container className={classes.titleWrap}>
          <Typography variant="h1">{activeTab === 'settings' ? 'Settings' : 'Entity'}</Typography>
          <Typography className={classes.titleId}>
            ({activeTab === 'settings' ? get(entity.settings, 'id') : entity.id})
          </Typography>
        </Grid>
      )}
      {businessEntityDetailsIsLoading ? (
        <Loader />
      ) : (
        <TabsComponent tabList={tabList} activeTab={activeTab} onChangeTab={handleTabChange} clientId={id} />
      )}
    </Grid>
  )
}
